import { render, staticRenderFns } from "./vehicle-filter.vue?vue&type=template&id=48b01dac"
import script from "./vehicle-filter.vue?vue&type=script&lang=js"
export * from "./vehicle-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports